var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from 'react';
import { paginate, mobilePaginate } from './paginationHelper';
import { PaginationItem } from './PaginationItem';
import { paginationStyles as classes } from './styles';
/**
 * A component that allows for navigating through paged results.
 *
 * @example
 * <Pagination currentPage={3} totalRecordCount={100} maxRecordsPerPage={6} />
 */
export const Pagination = React.forwardRef(function Pagination(_a, ref) {
    var { currentPage, totalRecordCount, maxRecordsPerPage, siblings = { desktop: 1, mobile: 2 }, boundaries = 1, color = 'blue', renderItem = (props) => _jsx(PaginationItem, Object.assign({}, props)), pageLabel = (page) => `Go to page ${page}`, prevLabel = 'Go to previous page', nextLabel = 'Go to next page', onPageChange } = _a, props = __rest(_a, ["currentPage", "totalRecordCount", "maxRecordsPerPage", "siblings", "boundaries", "color", "renderItem", "pageLabel", "prevLabel", "nextLabel", "onPageChange"]);
    const paginationSiblings = typeof siblings === 'number' ? { desktop: siblings, mobile: siblings } : siblings;
    const totalPages = Math.ceil(totalRecordCount / maxRecordsPerPage);
    const paginationItems = paginate(currentPage, totalPages, paginationSiblings.desktop, boundaries);
    const mobilePaginationItems = mobilePaginate(currentPage, totalPages, paginationSiblings.mobile);
    return (_jsxs("nav", Object.assign({ ref: ref, "aria-label": 'Pagination', css: classes.pagination }, props, { children: [renderItem({
                type: 'previous',
                color,
                label: prevLabel,
                page: currentPage - 1,
                disabled: currentPage <= 1,
                onPageChange,
            }), _jsx("div", { css: [classes.pagination, classes.desktopPagination], children: paginationItems.map((page, index) => {
                    return (_jsx(React.Fragment, { children: page ? (renderItem({
                            type: 'page',
                            color,
                            label: pageLabel(page),
                            page,
                            isSelected: page === currentPage,
                            onPageChange,
                        })) : (_jsx(PaginationItem, { type: 'dots', color: color })) }, index));
                }) }), _jsx("div", { css: [classes.pagination, classes.mobilePagination], children: mobilePaginationItems.map((page, index) => {
                    return (_jsx(React.Fragment, { children: renderItem({
                            type: 'page',
                            color,
                            label: pageLabel(page),
                            page,
                            isSelected: page === currentPage,
                            onPageChange,
                        }) }, index));
                }) }), renderItem({
                type: 'next',
                color,
                label: nextLabel,
                page: currentPage + 1,
                disabled: currentPage >= totalPages,
                onPageChange,
            })] })));
});
